export default [
  // {
  //   header: 'Home',
  //   title: 'Home',
  //   icon: 'HomeIcon',
  //   route: 'apps-home',
  // },
]
